export default __webpack_public_path__ + "static/media/raytracer.6d5a9143.png";